import { CancelledError } from '@tanstack/react-query'
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import shouldBeLoggedIn from '#app/guards/should-be-logged-in'
import ClientDataProvider from '#app/middlewares/providers/client-data'
import { NavigatableLayout } from '#widgets/layouts/navigatable-layout'
import { clientMeQueryOptions } from '#entities/client'
import { getCurrentUserRoleInfo, keycloak } from '#shared/lib/auth'

export const Route = createFileRoute('/client/_post-registration-required')({
  component: () => (
    <ClientDataProvider>
      <NavigatableLayout>
        <Outlet />
      </NavigatableLayout>
    </ClientDataProvider>
  ),

  loader: async ({ context }) => {
    await shouldBeLoggedIn()

    const { queryClient } = context
    const roleInfo = getCurrentUserRoleInfo()

    if (import.meta.env.PUBLIC_PLATFORM === 'telegram' && !keycloak.didInitialize) {
      throw redirect({ to: '/client/tg-preregister' })
    }

    // Client exists in keycloak, but not in users ms
    if (!roleInfo.isGiven && keycloak.didInitialize) {
      throw redirect({ to: '/client/post-register' })
    }

    try {
      await queryClient.ensureQueryData(clientMeQueryOptions)
    } catch (error) {
      if (error instanceof CancelledError) return
      throw error
    }
  },
})
